import React from "react";
import tools from "../../../helpers/tools";

const CatalogResearchResultItem = ({ catalog, selectedCount, onSelect }) => {
  return (
    <div className="mb-2">
      <a
        href="#"
        className={`w-100 btn btn-primary btn-sm`}
        onClick={() => onSelect(catalog)}
      >
        <div className="row p-2">
          <div className="col-10 pr-0">
            <div className="text-left">
              <div className="badge badge-light mb-2">
                {catalog.catalog.name}
              </div>
            </div>
            <div className="text-left" style={{ fontSize: 14 }}>
              {[
                catalog.brand.name,
                catalog.brandModel.name,
                catalog.type.name,
                catalog.brandModelFinish.name,
                catalog.optionsNotIncluded?.map((o, k) => o.name),
              ]
                .filter((item) => !Array.isArray(item) || item.length > 0)
                .join(" - ")}
            </div>
            {catalog.createdAt && (
              <div className="text-left font-italic" style={{ fontSize: 12 }}>
                Créé le {tools.formatDate(catalog.createdAt)}
              </div>
            )}
          </div>
          <div className="col-2 d-flex align-items-center justify-content-center px-0 pr-2">
            <i style={{ fontSize: "x-large" }} className="fa fa-plus mr-2" />
            <span style={{ fontSize: 14 }}>{selectedCount}</span>
          </div>
        </div>
      </a>
    </div>
  );
};

export default CatalogResearchResultItem;
